/* background.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./background.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled';
var styles = {
  background: "_bfhkvuon _1tke1osq"
};
export var Background = function Background(_ref) {
  var children = _ref.children,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement(Stack, {
    xcss: styles.background,
    testId: testId
  }, children);
};